(() => {
  if (customElements.get('bundle-card')) {
    return;
  }

  class BundleCard extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        wrapper: 'data-island.bundle-product',
        addButton: '[data-add]',
        quantityHolder: '[data-quantity-holder]',
        quantityInput: '[data-quantity]',
        increaseQtyButton: '[data-increase-qty]',
        decreaseQtyButton: '[data-decrease-qty',
        removeIcon: `[data-remove-icon]`,
        decreaseIcon: '[data-decrease-icon]',
        sellingPlansData: '[data-selling-plans]'
      }

      this.collection = this.getAttribute('data-collection');
      this.productId = this.getAttribute('data-product-id');
      this.variantId = this.getAttribute('data-variant-id');
      this.price = this.getAttribute('data-price');
      this.discountedPrice = this.getAttribute('data-discounted-price');
      this.title = this.getAttribute('data-title');

      this.sellingPlans = null;
    }

    /**
     * Toggle bundle card.
     * 
     * @param {Boolean} shouldAdd 
     * @returns {Void}
     */
    toggleBundleCard(shouldAdd = true) {
      this.classList.toggle('is-selected', shouldAdd);
      this.addButton.classList.toggle('is-visible', !shouldAdd);
      this.quantityHolder.classList.toggle('is-visible', shouldAdd);

      if (!shouldAdd) {
        return;
      }
      this.increaseQuantity();
    }

    /**
     * Get price.
     * 
     * @returns {Number}
     */
    getPrice() {
      return Number(this.price) * this.getQuantity();
    }

    /**
     * Get discounted price.
     * 
     * @returns {Number}
     */
    getDiscountedPrice() {
      return Number(this.discountedPrice) * this.getQuantity();
    }

    /**
     * Get quantity.
     * 
     * @returns {Number}
     */
    getQuantity() {
      return parseInt(this.quantityInput.value);
    }

    /**
     * Get bundle data.
     * 
     * @returns {Object}
     */
    getBundleData() {
      return {
        title: this.title,
        productId: this.productId,
        variantId: this.variantId,
        collection: this.collection,
        quantity: this.getQuantity(),
        price: this.getPrice(),
        discountedPrice: this.getDiscountedPrice(),
        sellingPlans: this.sellingPlans
      };
    }
    
    /**
     * Update quantity.
     */
    updateQuantity() {
      this.updateDecreaseIcon();
      this.dispatchEvent(new CustomEvent('bundle:quantity:update', {
        detail: this.getBundleData(),
        bubbles: true
      }));
    }

    /**
     * Increase quantity.
     * 
     * @param {Event} event?
     */
    increaseQuantity(event) {
      event?.preventDefault();
      this.quantityInput.value = this.getQuantity() + 1;
      this.updateQuantity();
    }

    /**
     * Update decrease icon.
     */
    updateDecreaseIcon() {
      this.decreaseIcon.classList.toggle('hidden', this.getQuantity() === 1);
      this.removeIcon.classList.toggle('hidden', this.getQuantity() > 1);
    }

    /**
     * Decrease quantity.
     * 
     * @param {Event} event?
     * @returns {Void}
     */
    decreaseQuantity(event) {
      event.preventDefault();
      this.quantityInput.value = this.getQuantity() - 1;
      this.updateQuantity();
      if (this.getQuantity() > 0) {
        return;
      }
      this.toggleBundleCard(false);
    }

    /**
     * Add listeners.
     */
    addListeners() {
      this.addButton.addEventListener('click', this.toggleBundleCard.bind(this));
      this.increaseQtyButton.addEventListener('click', this.increaseQuantity.bind(this));
      this.decreaseQtyButton.addEventListener('click', this.decreaseQuantity.bind(this));
      this.quantityInput.addEventListener('change', this.updateQuantity.bind(this));
    }
    
    /**
     * Cache elements.
     * 
     * @returns {Void}
     */
    cacheElements() {
      this.addButton = this.querySelector(this.selectors.addButton);
      this.quantityHolder = this.querySelector(this.selectors.quantityHolder);

      if (!this.addButton || !this.quantityHolder) {
        console.error('Missing elements in bundle card');
        return;
      }
      
      this.quantityInput = this.querySelector(this.selectors.quantityInput);
      this.increaseQtyButton = this.querySelector(this.selectors.increaseQtyButton);
      this.decreaseQtyButton = this.querySelector(this.selectors.decreaseQtyButton);
      this.removeIcon = this.decreaseQtyButton.querySelector(`${this.selectors.removeIcon}`);
      this.decreaseIcon = this.decreaseQtyButton.querySelector(`${this.selectors.decreaseIcon}`);

      this.sellingPlans = JSON.parse(this.querySelector(this.selectors.sellingPlansData).textContent);
    }
    
    /**
     * Connected callback.
     */
    connectedCallback() {
      this.classList.add('is-loaded');
      this.wrapper = this.closest(this.selectors.wrapper);
      if (!this.wrapper) {
        console.error('No wrapper found for bundle card');
      }
      this.cacheElements();
      this.addListeners();
    }
  }

  customElements.define('bundle-card', BundleCard);
})();